import(/* webpackMode: "eager" */ "/app/app/[locale]/products/analytics/page.tsx");
